import { cleanDecimal } from '~/utils/number';
import { dayjsTz } from '~/utils/dayjs';

const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * SECONDS_IN_MINUTE;

export enum AnalyticInterval {
  DAY = 'DAY',
  HOUR = 'HOUR',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
  WEEK = 'WEEK',
  YEAR = 'YEAR',
}

export const getTimeDurationLabel = (valueInSeconds: number): string => {
  let data = valueInSeconds;
  if (!Number.isFinite(valueInSeconds) || valueInSeconds == null) {
    data = 0;
  }

  const fixedValue = cleanDecimal(data);
  if (data >= SECONDS_IN_HOUR) {
    // Greater than or equal to 1 hour
    const hours = Math.floor(data / SECONDS_IN_HOUR);
    const minutes = Math.floor((data % SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);
    const seconds = Math.floor(data % SECONDS_IN_MINUTE);
    return `${hours}h ${minutes}m ${seconds}s`;
  } else if (data >= SECONDS_IN_MINUTE) {
    // Greater than or equal to 1 minute
    const minutes = Math.floor(data / SECONDS_IN_MINUTE);
    const seconds = Math.floor(data % SECONDS_IN_MINUTE);
    return `${minutes}m ${seconds}s`;
  } else {
    // Less than 1 minute
    return `${fixedValue}s`;
  }
};

export const getFormattedByInterval = (
  value: string | number | null,
  interval?: AnalyticInterval,
  options?: {
    isExpandDetail?: boolean;
  },
): string => {
  if (!value) return '';

  const optionFormat = options?.isExpandDetail
    ? {
        formatHouse: 'MMM D, h:mm A',
        formatDay: 'MMM D, YYYY',
        formatMonth: 'MMM YYYY',
        formatYear: 'MMM YYYY',
      }
    : {
        formatHouse: 'h A',
        formatDay: 'MMM D',
        formatMonth: 'MMM YYYY',
        formatYear: 'YYYY',
      };
  switch (interval) {
    case AnalyticInterval.HOUR: {
      return dayjsTz(value).format(optionFormat.formatHouse);
    }
    case AnalyticInterval.DAY:
    case AnalyticInterval.WEEK:
      return dayjsTz(value).format(optionFormat.formatDay);
    case AnalyticInterval.MONTH:
      return dayjsTz(value).format(optionFormat.formatMonth);
    case AnalyticInterval.QUARTER:
      const d = dayjsTz(value);
      return `Q${d.quarter()} ${d.format('YYYY')}`;
    case AnalyticInterval.YEAR:
      return dayjsTz(value).format(optionFormat.formatYear);
  }

  return dayjsTz(value).format(optionFormat.formatMonth);
};
